import reduxFetch from 'react-redux-fetch';
import { ORGANISATION_USER_GROUPS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const OrganisationUserGroupsService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_USER_GROUPS_RESOURCE,
      method: 'get',
      request: organisationId => ({
        url: apiRoutes.userGroups(organisationId),
      }),
    },
  ])(ComposedComponent);

export default OrganisationUserGroupsService;
